import { useI18n } from "@expertloop/i18n/react";
import type { MessageKey } from "@expertloop/i18n";
import type { AnalyticsPeriodKey } from "@expertloop/shared";

/*
 * Les quatre fenêtres d'observation servies par le serveur, dans l'ordre où
 * elles lui sont demandées. La liste vit ici plutôt que dans chaque page :
 * deux écrans qui proposeraient des périodes différentes donneraient deux
 * lectures inconciliables de la même plateforme.
 */
const PERIODS: { key: AnalyticsPeriodKey; labelKey: MessageKey }[] = [
	{ key: "7d", labelKey: "adminOverview.period7d" },
	{ key: "30d", labelKey: "adminOverview.period30d" },
	{ key: "month", labelKey: "adminOverview.periodMonth" },
	{ key: "12m", labelKey: "adminOverview.period12m" },
];

interface PeriodPickerProps {
	value: AnalyticsPeriodKey;
	onChange: (period: AnalyticsPeriodKey) => void;
}

export function PeriodPicker({ value, onChange }: PeriodPickerProps) {
	const { t } = useI18n();

	return (
		<div className="admin-overview__periods" role="group" aria-label={t("adminOverview.periodLabel")}>
			{PERIODS.map((entry) => (
				<button
					key={entry.key}
					type="button"
					className={`admin-overview__period ${value === entry.key ? "is-active" : ""}`}
					aria-pressed={value === entry.key}
					onClick={() => onChange(entry.key)}
				>
					{t(entry.labelKey)}
				</button>
			))}
		</div>
	);
}
